export const CATEGORY_LABELS = {
  language: 'Languages',
  framework: 'Frameworks',
  library: 'Libraries',
  tool: 'Tools',
  runtime: 'Runtimes',
  plugin: 'Plugins',
  other: 'Other',
};

export const CATEGORY_ORDER = [
  'language',
  'framework',
  'library',
  'runtime',
  'tool',
  'plugin',
  'other',
];
